/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Filter_AllInputs */

const en_gc_resources_filter_all = /** @type {(inputs: Gc_Resources_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All guides`)
};

const zh_gc_resources_filter_all = /** @type {(inputs: Gc_Resources_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部指南`)
};

/**
* | output |
* | --- |
* | "All guides" |
*
* @param {Gc_Resources_Filter_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_filter_all = /** @type {((inputs?: Gc_Resources_Filter_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Filter_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_filter_all(inputs)
	return zh_gc_resources_filter_all(inputs)
});
export { gc_resources_filter_all as "gc.resources.filter.all" }